import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
import QuillResizeImage from 'quill-resize-image';
import { Quill, type QuillOptions } from 'react-quill';

const ATTRIBUTES = ['alt', 'height', 'width', 'style'];

const ParchmentEmbed = Quill.import('blots/block/embed');
class ImageWithStyle extends ParchmentEmbed {
  static create(value: unknown) {
    const node = super.create(value);
    if (typeof value === 'string') {
      node.setAttribute('src', this.sanitize(value));
    }
    return node;
  }

  static formats(domNode: HTMLElement) {
    // debugger;
    return ATTRIBUTES.reduce(function (formats: Record<string, unknown>, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  static match(url: string) {
    return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
  }

  static sanitize(url: string) {
    return url;
    // return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
  }

  static value(domNode: HTMLElement) {
    return domNode.getAttribute('src');
  }

  format(name: string, value: string) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

ImageWithStyle.blotName = 'imagewithstyle';
ImageWithStyle.tagName = 'IMG';
Quill.register(ImageWithStyle, true);

Quill.register('modules/resize', QuillResizeImage);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);

export const descriptionEditorOptions: QuillOptions = {
  modules: {
    clipboard: {
      matchers: [
        // Для любых элементов
        [
          Node.ELEMENT_NODE,
          (_node: Node, delta: any) => {
            // Пробегаемся по всем операциям
            delta.ops.forEach((op: any) => {
              // Удаляем атрибут style, если он есть
              if (op.attributes && op.attributes.style) {
                delete op.attributes.style;
              }
              // Если это вставка картинки, пересоздаём только с src
              if (op.insert && op.insert.image) {
                op.insert = { image: op.insert.image };
              }
            });
            return delta;
          },
        ],
      ],
    },
    toolbar: [
      ['bold', 'italic', 'underline', 'link', 'image'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, false] }],
      [{ align: [] }],
      [
        {
          color: [
            '#616F82',
            '#DD64B3',
            '#693FAE',
            '#505CCE',
            '#4198C5',
            '#499C70',
            '#FFAD4B',
            '#F26501',
            '#FF0000',
            '#161718',
          ],
        },
      ],
    ],
    resize: {
      locale: {
        center: 'центр',
        floatLeft: 'влево',
        floatRight: 'вправо',
        restore: 'сброс',
      },
    },
    imageDropAndPaste: {},
  },
  formats: [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'color',
    'indent',
    'link',
    'image',
    'align',
    'style',
    'imagewithstyle',
    'alt',
    'width',
    'height',
    'style',
  ],
};
